import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import { Form, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import * as yup from 'yup';

import CardTitle from 'components/ui/CardTitle/CardTitle';
import { renderField } from 'core/utils/formik';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

const AccountRemindersForm = ({ handleSubmit, isSubmitting, isValid, values }) => {
  const { cross_checks_enabled } = values;

  return (
    <Form onSubmit={handleSubmit}>
      <Card className="pageCard">
        <CardHeader>
          <CardTitle>Reminders</CardTitle>
        </CardHeader>
        <CardBody className="padded">
          <Field
            type="number"
            name="device_calibration_threshold"
            label="CR Calibration Reminder"
            helpText="number of days before expiration date"
            component={renderField}
          />

          <Field
            type="number"
            name="duplicates_threshold"
            label="CR Duplicates Reminder"
            helpText="number of tests between reminders"
            component={renderField}
          />

          <Field
            type="switch"
            name="cross_checks_enabled"
            label="Enable CR Cross Checks Reminder"
            helpText="enables reminder to perform a CRM cross check"
            component={renderField}
          />

          {cross_checks_enabled && (
            <Field
              type="number"
              name="cross_checks_threshold"
              label="CR Cross Checks Reminder"
              helpText="number of days between reminders"
              component={renderField}
            />
          )}

          <Field
            type="number"
            name="passive.duplicates_threshold"
            label="Passive Duplicates Reminder"
            helpText="number of tests between reminders"
            component={renderField}
          />

          <Field
            type="number"
            name="passive.blanks_threshold"
            label="Passive Blanks Reminder"
            helpText="number of tests between reminders"
            component={renderField}
          />

          <Field
            type="number"
            name="passive.spikes_threshold"
            label="Passive Spikes Reminder"
            helpText="number of tests between reminders"
            component={renderField}
          />
        </CardBody>
        <CardFooter>
          <Button
            color="primary"
            disabled={!isValid || isSubmitting}
          >
            Save
          </Button>
        </CardFooter>
      </Card>
    </Form>
  );
};

AccountRemindersForm.propTypes = propTypes;

export default withFormik({
  mapPropsToValues: ({ initialValues }) => Object.assign({
    device_calibration_threshold: 30,
    duplicates_threshold: 10,
    cross_checks_enabled: true,
    cross_checks_threshold: 180,
  }, initialValues),
  validationSchema: yup.object().shape({
    device_calibration_threshold: yup.number().required('Required'),
    duplicates_threshold: yup.number().required('Required'),
    cross_checks_enabled: yup.boolean().required('Required'),
    cross_checks_threshold: yup.number().min(30).required('Required'),
  }),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
  displayName: 'AccountRemindersForm',
  isInitialValid: () => true,
})(AccountRemindersForm);



// WEBPACK FOOTER //
// ./src/features/Account/accountReminders/AccountRemindersForm.js